import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'wash-dryclean', 'WashDryclean', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}]]);